wbApp.factory('courseCategorySvc', ['$resource', '$translate',
    function ($resource, $translate) {

        function getAll() {
            return [
                { courseCategoryID: 1, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_OTHERS') },
                { courseCategoryID: 2, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_SWIMMING') },
                { courseCategoryID: 3, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_LANGUAGES') },
                { courseCategoryID: 4, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_MOTIONAL') },
                { courseCategoryID: 5, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_PREGNANCY') },
                { courseCategoryID: 6, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_SUBURBAN') },
                { courseCategoryID: 7, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_CREATIVE') },
                { courseCategoryID: 8, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_MUSIC') },
                { courseCategoryID: 9, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_DANCING') },
                { courseCategoryID: 10, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_LOGIC') },
                { courseCategoryID: 11, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_ACROBATICS') },
                { courseCategoryID: 12, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_SPORTS') },
                { courseCategoryID: 13, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_FREE_TIME') },
                { courseCategoryID: 14, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_FIGHTING') },
                { courseCategoryID: 15, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_THEATRE') },
                { courseCategoryID: 16, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_SERVICES') },
                { courseCategoryID: 17, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_EDUCATION') },
                { courseCategoryID: 18, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_COGNITIVE') },
                { courseCategoryID: 19, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_ART') },
                { courseCategoryID: 20, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_HEALTH') },
                { courseCategoryID: 21, text: $translate.instant('TXT_VAL_COURSE_CATEGORY_PARENTS_WITH_CHILDREN') }
            ];
        }

        return {
            getAll: getAll,
        }

    }]);